import { useState } from 'react';
import Cookies from 'js-cookie';
import { Capacitor } from '@capacitor/core';

function readLocalSession(key) {
    try {
        const raw = window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        return null;
    }
}

function writeLocalSession(key, value) {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.log(error);
    }
}

export function useCookieStorage(key, initialValue) {
    const [storedValue, setValue] = useState(() => {
        try {
            const sessionCookie = Cookies.get(key);
            if (sessionCookie) return JSON.parse(sessionCookie);
        } catch (error) {
            /* cookie missing or unreadable */
        }
        // Android/iOS WebView drops document cookies when the app process ends.
        if (Capacitor.isNativePlatform()) {
            const stored = readLocalSession(key);
            if (stored) return stored;
        }
        return initialValue;
    });

    const setCookieStorage = (value) => {
        try {
            Cookies.remove(key);
            Cookies.set(key, JSON.stringify(value), { expires: 5 });
        } catch (error) {
            console.log(error);
        }
        writeLocalSession(key, value);
        setValue(value);
    };

    const updateCookieStorage = (value) => {
        try {
            Cookies.set(key, JSON.stringify(value), { expires: 5 });
        } catch (error) {
            console.log(error);
        }
        writeLocalSession(key, value);
        setValue(value);
    };

    const deleteCookieStorage = () => {
        try {
            Cookies.remove(key);
            window.localStorage.removeItem(key);
            setValue(initialValue);
        } catch (error) {
            console.log('Error at deleting the cookie', error);
        }
    };

    return [
        storedValue,
        setCookieStorage,
        updateCookieStorage,
        deleteCookieStorage,
    ];
}
